import { AssociatedProduct } from '../../../_shared/models/product';
import { WebApiService } from '../../WebApiService';
import { DbTable } from '../db-table';
import { HttpClient } from '@angular/common/http';

export class DbAssociatedProducts extends DbTable<AssociatedProduct> {

    constructor(public _http: HttpClient,public _webApi:WebApiService, public productId: number) {

        super(_http,_webApi, `products/${productId}/associatedproducts`);

    }

}